import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import BottomNarBar from "../../BottomNav/Bottom";
import PickupTimer from "./timer";
import AddGoogleNumber from "../Userprofile/AddGoogleNumber";
import GoogleNumberOtpModal from "../Userprofile/GoogleNumberOtpModal";
import GoogleSuccessModal from "../Userprofile/GoogleSuccessModal";
import OrdersSkeleton from "./OrderSkeleton";
import "../Orders/orders.css";
import whitearrow from "../../assets/whitearrow.png"
import { getDigitalStatus } from "../../Utils/getDigitalStatus";
import logger from "../../Utils/logger";
// ─── Sub-components ────────────────────────────────────────────────────────────

const TopNav = () => (
  <div className="_2456r">
    <div className="_3nxa7" data-testid="listing-header-location">
      <button className="_1NdRR" aria-label="Past Orders" id="change-address-btn-id">
        <div style={{ display: "flex", alignItems: "center" }}>
          <h2 style={{ marginLeft: "25px", fontSize: "18px", color: "#583C43", fontWeight: "500" }}>
            Past Orders
          </h2>
        </div>
      </button>
      <span className="icon-Offers-outline _2P0Ff" />
    </div>
  </div>
);

const ChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
  </svg>
);

const ProductImageRow = ({ items, imageKey }) => (
  <div className="relative flex">
    {items.slice(0, 3).map((item, i) => (
      <img
        key={i}
        src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${item[imageKey]}`}
        alt="product"
        style={{
          width: "40px", height: "40px", padding: "8px",
          marginLeft: "5px", border: "1px solid #ccc", borderRadius: "9px",
        }}
      />
    ))}
    {items.length > 3 && (
      <div
        className="countPlus"
        style={{
          width: "40px", height: "40px", padding: "8px", marginLeft: "5px",
          border: "1px solid #ccc", borderRadius: "9px",
          display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold",
        }}
      >
        +{items.length - 3}
      </div>
    )}
  </div>
);

const btnBase = {
  display: "flex", padding: "0px 12px 0px 16px",
  justifyContent: "space-between", alignItems: "center",
  alignSelf: "stretch", borderRadius: "10px", height: "50px",
  border: "1px solid rgba(148, 163, 184, 0.54)",
};
const ActiveOrderCard = ({ order, onPickup }) => {
  if (!order?.vendingMachineId || order.vendingMachineId <= 1) return null;

  logger.log("order",order)
const digitalStatus = getDigitalStatus(order?.lineItems);
logger.log("digitalStatus", digitalStatus);
  return (
    <div style={{ padding: "2%" }}>
      <div className="divBox" style={{ padding: "5%" }}>
        <div style={{ padding: "2%" }}>
          <div className="flex justify-between items-center">
            <p className="font-roboto font-semibold" style={{ color: "#718198", fontSize: "15px" }}>
              PickUp Code:{" "}
              <span className="orderIdValue" style={{ fontSize: "18px" }}>{order.dcCode || ""}</span>
            </p>
            <p className="font-roboto font-semibold price">
              {order?.amount != null ? `₹${order.amount.toFixed(2)}` : ""}
            </p>
          </div>
          <p className="text-sm text-gray-600 font-roboto address">{order?.vendingMachineAddress || ""}</p>
          <div className="flex mt-0">
            <p className="text-gray-700 font-roboto text-sm font-medium itemsCount">
              {order?.lineItems?.length} items
            </p>
            <PickupTimer createdAt={order.createdAt} pickupTime={order.pickupTime} />
          </div>
        </div>
        <div className="w-336 h-100 mt-4 flex items-center justify-between">
          <ProductImageRow items={order?.lineItems || []} imageKey="imageUrl" />
          <div onClick={() => onPickup(order?.orderId,digitalStatus)} style={{ ...btnBase, background: "#00B177",width:"130px",cursor:"pointer" }}>
            <div className="viewDetails" style={{ color: "white", fontWeight: "500", fontSize: "13px" }}>
              {digitalStatus === true ? "Claim Order" : "PickUp Order"}
            </div>
            <div style={{ display:"flex", alignItems:"center" }}>
              <img src={whitearrow} alt="" style={{width:"10px"}}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PastOrderCard = ({ order, onViewDetails }) => {
  if (!order?.vendingMachineId || order.vendingMachineId <= 1) return null;
  const isCancelled = order.status === "cancelled";
  return (
    <div style={{ padding: "2%" }}>
      <div className="divBox" style={{ padding: "5%" }}>
        <div style={{ padding: "2%" }}>
          <div className="flex justify-between items-center">
            <p className="font-roboto font-semibold" style={{ color: "#718198", fontSize: "15px" }}>
              Order ID:{" "}
              <span className="orderIdValue" style={{ fontSize: "15px" }}>{order.orderId || ""}</span>
            </p>
            <p className="font-roboto font-semibold price">
              {order.amount != null ? `₹${order.amount.toFixed(2)}` : ""}
            </p>
          </div>
          <p className="text-sm text-gray-600 font-roboto address">{order.vendingMachineAddress || ""}</p>
          <div className="flex mt-0">
            <p className="text-gray-700 font-roboto text-sm font-medium itemsCount">
              {order.orderLineItems?.length} items
            </p>
            <h3
              className="font-roboto text-sm font-medium ml-1"
              style={{ color: isCancelled ? "red" : "green" }}
            >
              {" "}• {order.status || ""}
            </h3>
          </div>
        </div>
        <div className="w-336 h-100 mt-4 flex items-center justify-between">
          <ProductImageRow items={order.orderLineItems || []} imageKey="imageUrl" />
          <div style={btnBase}>
            <div onClick={() => onViewDetails(order.orderId)} className="viewDetails">View Details</div>
            <div className="viewDetailsIcon"><ChevronRight /></div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ─── Main component ────────────────────────────────────────────────────────────

function Orders(props) {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const inputOtpRef = useRef(null);

  useEffect(() => {
    if (props?.otp && inputOtpRef.current) inputOtpRef.current.focus();
  }, [props?.otp]);

  useEffect(() => {
    if (props?.number && inputRef.current) inputRef.current.focus();
  }, [props?.number]);

  const gotoDetails    = (orderId) => navigate(`/orders/Details/${orderId}`);
  const goToPickUpOrder = (orderId,digitalStatus) =>{
    logger.log("digitalStatus",digitalStatus)
/*   if(digitalStatus=="mixed"|| digitalStatus==true){
    navigate(`/orders/Details/${orderId}`)

  }else{
    //navigate(`/orders/Details/${orderId}`)
    //navigate(`/pickupOptions/${orderId}`)
  }
 */
navigate(`/pickupOptions/${orderId}`)

  };

  const isGuest       = Boolean(localStorage.getItem("isGuest"));
  const hasActiveOrders = props.activeOrderhistory?.length > 0;

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      {/* ── Modals ── */}
      {props?.google_success_flag && <GoogleSuccessModal />}

      {props?.google_OTP_Pop_flag && (
        <GoogleNumberOtpModal
          setOtp={props?.setOtp}
          otp={props?.otp}
          googleOtpSubmit={props?.googleOtpSubmit}
          closeOTpPop={props?.closeOTpPop}
          google_OTP_Pop_flag={props?.google_OTP_Pop_flag}
          otpErrorMsg={props?.otpErrorMsg}
          otpError={props?.otpError}
          googleAddnumber={props?.googleAddnumber}
        />
      )}

      {props?.google_Pop_flag && !isGuest && (
        <AddGoogleNumber
          google_Pop_flag={props?.google_Pop_flag}
          googleAddnumber={props?.googleAddnumber}
          closePop={props?.closePop}
          setNumber={props?.setNumber}
          number={props?.number}
          numberError={props?.numberError}
          numberErrorMsg={props?.numberErrorMsg}
        />
      )}

      <BottomNarBar />
      <TopNav />

      <div
        style={{
          background: "radial-gradient(circle, rgba(245,233,233,0.408) 0%, rgba(185,245,247,0.34) 100%)",
          maxWidth: "500px",
          width: "100%",
        }}
        className="pb-20 pt-20 overflow-y-auto h-screen"
      >
        {/* ── Skeleton replaces spinner while data loads ── */}
        {props.loader ? (
          <OrdersSkeleton activeCount={1} pastCount={4} />
        ) : (
          <>
            {/* Active orders */}
            {hasActiveOrders && <h1 style={{ padding: "15px" }}>Today's Active Orders</h1>}
            {props.activeOrderhistory?.map((order, index) => (
              <ActiveOrderCard
                key={order?.orderId || index}
                order={order}
                onPickup={goToPickUpOrder}
              />
            ))}

            {/* Past orders */}
            <h1 style={{ padding: "15px" }}>Past Orders</h1>
            {props.orderhistory?.map((order, index) => (
              <PastOrderCard
                key={order?.orderId || index}
                order={order}
                onViewDetails={gotoDetails}
              />
            ))}

            {/* Empty state */}
            {!props.orderhistory?.length && (
              <div style={{ textAlign: "center", padding: "60px 20px", color: "#94a3b8" }}>
                <p style={{ fontSize: "16px" }}>No past orders yet</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Orders;
